import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { voucherSchema } from '../types';

export const createDeleteVoucherMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'DELETE',
			url: (id) => `/voucher/${id}`,
			body: () => ({}),
		},
		response: {
			contract: zodContract(voucherSchema),
		},
	});
